module.exports = __webpack_public_path__ + "img/br1.6bb5b506.png";